export function safeGet(key: string): string | null {
  try {
    if (typeof window === 'undefined' || !('localStorage' in window)) return null
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export function safeSet(key: string, value: string): void {
  try {
    if (typeof window === 'undefined' || !('localStorage' in window)) return
    window.localStorage.setItem(key, value)
  } catch {
    // ignore
  }
}

export function safeRemove(key: string): void {
  try {
    if (typeof window === 'undefined' || !('localStorage' in window)) return
    window.localStorage.removeItem(key)
  } catch {
    // ignore
  }
}

export function safeGetJSON<T>(key: string): T | null {
  const raw = safeGet(key)
  if (!raw) {
    return null
  }

  try {
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}

export function safeSetJSON(key: string, value: unknown): void {
  try {
    safeSet(key, JSON.stringify(value))
  } catch {
    // ignore
  }
}

const LOCAL_DRAWER_FONT_SCALE_KEY = 'rpa:prep:drawerFontScale'
const LOCAL_PREP_LAYOUT_KEY = 'rpa:prep:layout'
const LOCAL_PREP_SINGLE_LAYOUT_SPLIT_KEY = 'rpa:prep:singleLayoutSplit'
const LOCAL_PREP_HEADLINE_LINES_KEY = 'rpa:prep:headlineLines'
const LOCAL_SHOW_CLOCK_LIVE_SPLIT_KEY = 'rpa:showClock:liveSplit'

export const getLocalDrawerFontScale = (): number | null => {
  const stored = safeGetJSON<number>(LOCAL_DRAWER_FONT_SCALE_KEY)
  return typeof stored === 'number' && Number.isFinite(stored) ? stored : null
}

export const setLocalDrawerFontScale = (value: number): void => {
  safeSetJSON(LOCAL_DRAWER_FONT_SCALE_KEY, value)
}

export const getLocalPrepLayout = (): 'columns' | 'single' | 'dashboard' | null => {
  const stored = safeGet(LOCAL_PREP_LAYOUT_KEY)
  if (stored === 'columns' || stored === 'single' || stored === 'dashboard') {
    return stored
  }
  return null
}

export const setLocalPrepLayout = (layout: 'columns' | 'single' | 'dashboard'): void => {
  safeSet(LOCAL_PREP_LAYOUT_KEY, layout)
}

export const getLocalPrepSingleLayoutSplit = (): number | null => {
  const stored = safeGetJSON<number>(LOCAL_PREP_SINGLE_LAYOUT_SPLIT_KEY)
  return typeof stored === 'number' && Number.isFinite(stored) ? stored : null
}

export const setLocalPrepSingleLayoutSplit = (value: number): void => {
  safeSetJSON(LOCAL_PREP_SINGLE_LAYOUT_SPLIT_KEY, value)
}

export const getLocalPrepHeadlineLines = (): number | null => {
  const stored = safeGetJSON<number>(LOCAL_PREP_HEADLINE_LINES_KEY)
  return typeof stored === 'number' && Number.isFinite(stored) ? stored : null
}

export const setLocalPrepHeadlineLines = (value: number): void => {
  safeSetJSON(LOCAL_PREP_HEADLINE_LINES_KEY, value)
}

export const getLocalShowClockLiveSplit = (): number | null => {
  const stored = safeGetJSON<number>(LOCAL_SHOW_CLOCK_LIVE_SPLIT_KEY)
  return typeof stored === 'number' && Number.isFinite(stored) ? stored : null
}

export const setLocalShowClockLiveSplit = (value: number): void => {
  safeSetJSON(LOCAL_SHOW_CLOCK_LIVE_SPLIT_KEY, value)
}
